module.exports = __webpack_public_path__ + "modules/platform/img/pc-baner1.jpg";